import React from 'react';

const StatsCard = ({ title, subtitle, action, children, padded = true, className = '' }) => (
    <section className={`stats-card ${className}`}>
        <header className="stats-card__header">
            <div>
                <h3 className="stats-card__title">{title}</h3>
                {subtitle && <p className="stats-card__subtitle">{subtitle}</p>}
            </div>
            {action && <div className="stats-card__action">{action}</div>}
        </header>
        <div className={`stats-card__body ${padded ? 'stats-card__body--padded' : ''}`}>
            {children}
        </div>
    </section>
);

export default StatsCard;
